// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3yQmX","productName":"Table_productName__Zem7I"};